import React from 'react';
import { triangleHead } from '../library/Svgs';

const OrganizationListItem = (props) => {
  const { url, image, title, portfolio, parent } = props;
  let class_names = "org-image";
  return (
    <li>
      <a href={url}>
        <div
          className={class_names}
          style={{
            background: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: 'white',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
          }}
          alt={title}
        >
          <div className="padding" />
        </div>
        <div className="org-title-wrapper">
          <span href={url} className="org-title">
            {title}
          </span>
          <span className="org-title-wrapper__portfolio-sub">
            {parent}
          </span>
          <span className="org-title-wrapper__portfolio-name">
            {portfolio}
          </span>
        </div>
        <span className="right-arrow">
          <span className="line" />
          <span className="circle-head" dangerouslySetInnerHTML={{ __html: triangleHead }} />
        </span>
      </a>
    </li>
  );
};

export default OrganizationListItem;
